import { adminAPIService, newhopeAPIService } from './index'

const route = 'deal-posts'

export default {
  list(keywords = '', isShowCPCDealPostOnly = false, page = 1, size = 50) {
    const params = { 
      keywords,
      is_show_cpc_deal_post_only: isShowCPCDealPostOnly ? 1 : 0,
      page,
      size
    }

    return newhopeAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  load(id) {
    // wupiupi-api does not support some emoji
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'get',
    })
  },
  create(payload) {
    // wupiupi-api does not support some emoji
    const body = `json=${encodeURIComponent(JSON.stringify(payload))}`
    return adminAPIService({
      url: route,
      method: 'post',
      data: body,
    })
  },
  update(id, payload) {
    const body = `json=${encodeURIComponent(JSON.stringify(payload))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  delete(id) {
    const payload = {
      is_deleted: 1
    }
    
    const body = `json=${encodeURIComponent(JSON.stringify(payload))}`
    return adminAPIService({
      url: `${route}/${id}`,
      method: 'post',
      data: body,
    })
  },
  listOptions() {
    return newhopeAPIService({
      url: `${route}/options`,
      method: 'get',
    })
  },
  search(names, targetDate) {
    const formData = new FormData()
    formData.append('names', names.join('|'))
    formData.append('target_date', targetDate)

    return adminAPIService({
      url: `${route}/search`,
      method: 'post',
      data: formData,
    })
  },
}
